import { useSelector } from 'react-redux';
import { selectMetadata } from '../redux/reportSlice';
import getCurrentDate from '../Common/getCurrentDate';
import moment from 'moment';

function ReportPage(props) {
  const { pageNumber, totalPages } = props;
  const metadata = useSelector(selectMetadata);
  const { version, header } = metadata;
  const title = header ? header.title : undefined;
  // When we build reports with a date range filter, these
  // will need to get set based on the filter setting
  const includeDate = false;
  const startDate = '1/1/2020';
  const endDate = '1/1/2020';
  const currentDate = getCurrentDate();
  const currentDateFormatted = moment(currentDate).format('dddd, MMMM DD, YYYY - h:mm A')
  return (
    <div className={"report-page"}>
      <h3 className={"text-center"}>{title}</h3>
      <div className="data-container">
        {props.children}
      </div>
      <footer className={"container-fuid"}>
        <div className={"row"}>
          <div className={"col-sm-1"}>
            <br />
            <img src="/Content/img/vanco-logo.png" className={"vanco-logo"} alt="" />
          </div>
          <div className={"col-sm-2 "}><br />Version: {version}</div>
          <div className={"col-sm-6 text-center"}>
            <span>
              {includeDate && `${startDate} - ${endDate}`}
              <br />
            </span>
            <span>
              Printed on {currentDateFormatted}
            </span>
          </div>
          <div className={"col-sm-3 text-right"}><br />Page {pageNumber} of {totalPages}</div>
        </div>
      </footer>
    </div>
  );
}
export default ReportPage;